import React from "react";
import "./Dashboard.scss";
import { useAuthStore } from "../../store/auth";
import Carousel from "../../components/Carousel/Carousel";
import Preview from "../../components/Preview/Preview";
import { Game } from '../../interfaces/interfaces';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import FloatingButtons from "../../components/FloatingButtons/FloatingButtons";
import ConfigGameBar from "../../components/ConfigGameBar/ConfigGameBar";
import { useConfigProvider } from "../../contexts/ConfigProvider";
import { useJackpots } from "../../hooks/useJackpots";
import { changeVBgameNames } from "../../utils";
import { PROVIDER_OPERATOR_ID } from "../../constants"
import { useConfigurationVersion } from "../../hooks/useConfigurationVersion";
import { useGameCurrencyStore } from "../../store/gameCurrency";
import { useCurrencies } from "../../hooks/useCurrencies";

type Props = {
  games: Game[];
  filtering: boolean;
  gameUrl: string;
  baseUrl: string;
  configUrl: string;
  defaultGameLanguage: string;
};

const Dashboard = ({ games, filtering, gameUrl, baseUrl, configUrl, defaultGameLanguage }: Props) => {
  const token = useAuthStore((state) => state.token);
  const currency = useGameCurrencyStore((state) => state.currency);
  const demo = token ? token === "withguest" : false;
  const { features } = useConfigProvider();
  const {data: jackpots} = useJackpots({baseUrl, providerOperatorId: PROVIDER_OPERATOR_ID, currency, gameName: ""});
  const {data: currencies} = useCurrencies();
  const {data: configurationVersion} = useConfigurationVersion();
  const filteredJackpots = games.map( game => jackpots && jackpots?.filter(jackpot => jackpot.games.includes(game.name) )).filter(jackpots => jackpots && jackpots.length > 0 );
  const maxValueJackpot = (filteredJackpots.length > 0 && filteredJackpots.map(jackpot => jackpot && jackpot.reduce((max, jackpot) => (jackpot.value > max.value ? jackpot : max)))) || null; 

  return (
    <div className="dashboard">
      <Header searchIsVisible={true} />
      {!filtering && (
        <div className="dashboard-main-carousel">
          <Carousel token={token} demo={demo} gameUrl={gameUrl} />
        </div>
      )}
      <FloatingButtons token={token} />
      {features.withConfigGameBar && <ConfigGameBar defaultGameLanguage={defaultGameLanguage}/>}
      <div className="dashboard-games">
        <div className={ features.withJackpots ?  "dashboard-games-list-jackpot" : "dashboard-games-list"}>
          {games.map((game) => ( configurationVersion &&
            <Preview
              game={game}
              key={game.name}
              token={token}
              currency={currency}
              demo={demo}
              gameUrl={gameUrl}
              configUrl={configUrl}
              currencies={currencies}
              jackpot= { maxValueJackpot && maxValueJackpot?.find(jackpot => {
                if(jackpot && jackpot.type === 'BASE30') {
                  const jackpotGames = jackpot.games.map(game => changeVBgameNames(game));
                  return jackpotGames.includes(game.name)
                }
                return jackpot && jackpot.games.includes(game.name)})!              
              }
              configurationVersion={configurationVersion}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default React.memo(Dashboard);
